import { useRef } from 'react'

import { useQuery } from '@fv/client-core'
import type { BillToDTO } from '@fv/client-types'

import { shipperFetch } from '@/utils/shipperFetch'

const fetchLoadBillTo = (loadId?: string) => async () => {
  if (!loadId) {
    throw new Error('fetchLoadBillTo called without loadId')
  }
  return shipperFetch<BillToDTO>(`/bill-to/load/${loadId}`)
}

export function useFetchLoadBillTo(
  loadId: string | undefined,
  hasAddress = false,
) {
  // Once the form has ever held an address, latch the fetch off. Editing the
  // city/state/zip clears the street address, which would otherwise re-enable
  // this query and overwrite the user's edits with the cached value. Swapping
  // the query key (rather than just disabling) ensures consumers stop seeing the
  // stale cached result for the original key once latched.
  const latchedRef = useRef(false)
  latchedRef.current = latchedRef.current || hasAddress
  const effectiveLoadId = latchedRef.current ? undefined : loadId

  return useQuery(
    ['loadBillTo', effectiveLoadId],
    fetchLoadBillTo(effectiveLoadId),
    {
      staleTime: Infinity,
      enabled: !!effectiveLoadId,
    },
  )
}
